<template>
  <form-item :styleSet="{alignItems:'center',justifyContent:'spaceBetween'}" label-width="80" class="mt-10"
             labelAlign="left" label="开启跳转">
    <div class="flex flex1" style="justify-content: flex-end">
      <el-switch @change="prop.bigJumpType = BIG_JUMP_TYPE.AIDA" v-model="prop.bigJump"></el-switch>
    </div>
  </form-item>
  <template v-if="prop.bigJump">
    <div class="bs-route-container" v-if="prop.jumpActions?.length">
      <div v-for="(item, index) in prop.jumpActions" :key="index" class="p-6 bs-route-item flex vcenter">
        <div class="flex1 over-font">{{ item.actionName }}</div>
        <el-icon class="cursor" @click="addAction(item,index)">
          <Edit/>
        </el-icon>
        <el-icon class="cursor" @click="delAction(index)">
          <Close/>
        </el-icon>
      </div>
    </div>
    <el-button class="mt-10" @click="addAction()" style="width: 100%">添加操作</el-button>
  </template>
  <el-dialog draggable width="400px" title="添加操作" v-model="showDialog">
    <form-item label="作用字段" label-width="80" labelAlign="left">
      <el-select
        v-model="tempData.fieldList"
        class="m-2 rule-row-item"
        placeholder="请选择数据"
        value-key="code"
        multiple
      >
        <el-option
            v-for="item in selectArr"
            :key="item.code"
            :label="item.name"
            :value="item"
        >
          <div class="cs-drag-item move bg ellipsis">
            <svg-icon
                color="#878f95"
                class="text m mr-4"
                :icon-class="getIcon(item.fieldType)"
            />
            <span>{{ item.name }}</span>
          </div>
        </el-option>
      </el-select>
    </form-item>
    <form-item required label="操作名称" label-width="80" labelAlign="left">
      <el-input v-model="tempData.actionName"></el-input>
    </form-item>
    <form-item label="操作编码" label-width="80" labelAlign="left">
      <el-input v-model="tempData.actionCode"></el-input>
    </form-item>
    <form-item label-width="80" labelAlign="left" label="页面类型" v-if="tempData.bigJumpKind != 'back'">
    </form-item>
    <el-radio-group class="radio-button-sm mb-10" v-model="tempData.bigJumpType" @change="tempData.jumpParams = []">
      <el-radio-button :label="BIG_JUMP_TYPE.AIDA">Aida页面</el-radio-button>
      <el-radio-button :label="BIG_JUMP_TYPE.EXTERNAL">外链</el-radio-button>
    </el-radio-group>
    <template v-if="tempData.bigJumpType === BIG_JUMP_TYPE.EXTERNAL">
      <form-item label="跳转方式" label-width="80" labelAlign="left">
      </form-item>
      <el-radio-group v-model="tempData.bigJumpKind" size="small" @change="paramSelect($event, true)" class="mb-10">
        <el-radio-button label="dialog" value="dialog">弹窗</el-radio-button>
        <el-radio-button label="inner" value="inner">刷新页面</el-radio-button>
        <el-radio-button label="outer" value="outer">新页面</el-radio-button>
        <el-radio-button label="back" value="back">返回上一页</el-radio-button>
      </el-radio-group>
      <template v-if="tempData.bigJumpKind === 'dialog'">
        <form-item
            labelAlign="left"
            tip="弹窗的标题"
            labelWidth="80"
            label="标题"
        >
          <el-input v-model="tempData.openTitle"></el-input>
        </form-item>
        <form-item labelAlign="left" labelWidth="80" label="宽度"
                   tip="弹窗的宽度，可输入数字字符串，如 100 100px 50%">
          <el-input v-model="tempData.openWidth"></el-input>
        </form-item>
        <form-item labelAlign="left" labelWidth="80" label="高度"
                   tip="弹窗的高度，可输入数字字符串，如 100 100px 50%">
          <el-input v-model="tempData.openHeight"></el-input>
        </form-item>
      </template>
    </template>
    <template v-if="tempData.bigJumpType === BIG_JUMP_TYPE.AIDA">
      <template v-if="editorType === 1">
        <form-item label-width="80" labelAlign="left" label="访问域名" tip="爱搭项目部署后的访问域名">
        </form-item>
        <el-input v-model="tempData.aidaDomain"/>
      </template>
      <div class="mb-10"></div>
      <OpenPageSet :app="app" :option="tempData"></OpenPageSet>
      <div class="mb-10"></div>
      <form-item label-width="80" labelAlign="left" label="参数关联">
        <el-button v-if="showAddParam" @click="addJumpParam" size="small" :icon="Plus"></el-button>
      </form-item>
      <el-table v-if="Array.isArray(tempData.jumpParams)" :data="tempData.jumpParams">
        <el-table-column label="参数" width="100">
          <template v-slot="{ row, $index }">
            <el-select v-model="row.paramKey" size="small" @change="paramSelect($event,true)">
              <template v-for="item in pageParams">
                <el-option v-if="!item.hidden" :key="item.fieldKey" :label="item.fieldName"
                           :value="item.fieldKey"></el-option>
              </template>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="{ row, $index }">
            <div class="flex vcenter">
              <BindModel showPageParam :linkData="linkData" :white="editorType===1"
                         v-model:bindParam="row.bindParam"></BindModel>
              <el-link :underline="false" class="ml-4" type="primary"
                       @click.stop="tempData.jumpParams.splice($index,1),paramSelect(row.paramKey,false)">删除
              </el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template v-if="tempData.bigJumpType === BIG_JUMP_TYPE.EXTERNAL && tempData.bigJumpKind != 'back'">
      <el-tabs :data-init="tempData.externalPathType||(tempData.externalPathType=LINK_TYPE.STATIC)"
               v-model="tempData.externalPathType">
        <el-tab-pane label="静态地址" :name="LINK_TYPE.STATIC">
          <div class="flex vcenter">
            <el-input v-model="tempData.externalPath"/>
            <el-tooltip effect="dark" content="如果有场景需要去除sessionKey,请在静态链接里添加固定参数sessionKey=null" placement="top">
              <el-icon class="fs-18 cursor ml-12">
                <QuestionFilled></QuestionFilled>
              </el-icon>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane label="动态地址" :name="LINK_TYPE.DYNAMIC">
          <el-input v-model="tempData.dynamicExternalPath">
            <template #suffix>
              <el-button @click="openCode" size="small" :icon="Edit"></el-button>
            </template>
          </el-input>
        </el-tab-pane>
      </el-tabs>
      <div class="mb-10"></div>
      <form-item label-width="80" labelAlign="left" label="参数关联">
        <el-button @click="addJumpParam" size="small" :icon="Plus"></el-button>
      </form-item>
      <el-table v-if="Array.isArray(tempData.jumpParams)" :data="tempData.jumpParams">
        <el-table-column label="参数" width="100">
          <template v-slot="{ row, $index }">
            <el-input v-model="row.paramKey"/>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="{ row, $index }">
            <div class="flex vcenter">
              <BindModel showPageParam :linkData="linkData" :white="editorType===1"
                         v-model:bindParam="row.bindParam"></BindModel>
              <el-link :underline="false" class="ml-4" type="primary"
                       @click.stop="tempData.jumpParams.splice($index,1),paramSelect(row.paramKey,false)">删除
              </el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #footer>
      <el-button @click="showDialog=false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </template>
  </el-dialog>
  <codeedit
      @submit="closeCode"
      v-if="code.box"
      :title="code.title"
      :type="code.type"
      v-model="code.obj"
      v-model:visible="code.box"
  ></codeedit>
</template>
<script setup>

import {BIG_JUMP_TYPE, LINK_TYPE, OPEN_PAGE_TYPE} from "@/option/common/dict";
import {Plus, Edit, Close, QuestionFilled} from "@element-plus/icons-vue";
import BindModel from "@/option/components/dataCenter/bindModel.vue";
import {computed, inject, reactive, ref, watchEffect} from "vue";
import {appMenuDao, sceneDao} from "@/option/common/dao";
import { MODEL_COLUMN_TYPE, METRIC_TYPE } from "@/option/common/dict.js";
import codeedit from "@/page/group/code.vue";
import {cloneDeep} from "lodash-es";
import {ElMessage, ElMessageBox} from "element-plus";
import OpenPageSet from './OpenPageSet.vue'

let editorType = inject('editorType')
let tempData = ref({})

let props = defineProps({
  prop: {},
  app: {},
  linkData: {}
})
let showDialog = ref(false)
let menus = ref([])
let code = reactive({
  title: "动态链接",
  box: false,
  type: "dynamicLink",
  obj: "",
})

let selectArr = computed(() => {
  let optionList = []
  if (props.prop?.columns && props.prop?.columns?.length) {
    optionList = [...props.prop?.columns, ...props.prop?.metrics]?.map(item => {
      return {
        ...item,
        fieldType: 'metric'
      }
    })
  } else {
    optionList = props.prop.metrics?.map(item => {
      return {
        ...item,
        fieldType: 'metric'
      }
    })
  }
  // 不需要维度
  // const dimensions = props.prop.dimensions?.map(item => {
  //   return {
  //     ...item,
  //     fieldType: 'dimension'
  //   }
  // })
  return [...optionList]
})

function getIcon(type) {
  switch (type) {
    case MODEL_COLUMN_TYPE.date:
      return "date";
    case MODEL_COLUMN_TYPE.number:
      return "123";
    case METRIC_TYPE.CUS:
      return "fx";
    default:
      return "abc";
  }
}

function openCode() {
  code.obj = tempData.value.dynamicExternalPath
  code.box = true;
}

function closeCode(value) {
  tempData.value.dynamicExternalPath = value;
}

function handleNodeClick(data, node) {
  let p;
  if (node.parent) {
    p = `${node.parent.data.path}/`;
  }
  p += node.data.path;
  // 这是真正的跳转路由 TODO 暂时考虑两级 多级不支持
  tempData.bigJumpPath = p;
  getPageParams(data)
}

let pageParams = ref([])
let showAddParam = computed(() => {
  return tempData.value?.jumpParams?.length !== pageParams.value.length
})

function addJumpParam() {
  if (!tempData.value.jumpParams) {
    tempData.value.jumpParams = []
  }
  tempData.value.jumpParams.push({})
}

// 获取跳转页面的入参
function getPageParams(v) {
  sceneDao
      .getByPageId({
        id: v.uri,
        appId: props.app.id,
        version: props.app.currentVersion,
      })
      .then((el) => {
        if (el.openApiDtoResDto) {
          pageParams.value = el.openApiDtoResDto.openApiDtoFieldsDtoList;
        }
      });
}

function paramSelect(v, flag) {
  if (!v) return;
  let el = pageParams.value.find(el => el.fieldKey === v)
  el.hidden = flag
}

function handledSavedMenu(list) {
  list.forEach((el) => {
    // 找到就删除
    el.label = el.showName || el.originalName;
    el.value = el.uri;
    if (el?.children?.length) {
      handledSavedMenu(el.children);
    }
  });
}

let editItem = null
let editIndex = null

function addAction(v, index) {
  editItem = v
  editIndex = index
  tempData.value = v ? cloneDeep(v) : {}
  showDialog.value = true
}

watchEffect(() => {
  if (tempData.value.aidaPageId) {
    getPageParams({uri: tempData.value.aidaPageId})
  }
})

function confirm() {
  if (!tempData.value.actionName) {
    return ElMessage.warning('请填写操作名称！')
  }
  if (!props.prop.jumpActions) {
    props.prop.jumpActions = []
  }
  if (editItem) {
    props.prop.jumpActions[editIndex] = tempData.value
  } else {
    props.prop.jumpActions.push(tempData.value)
  }
  showDialog.value = false
}

function delAction(index) {
  ElMessageBox.confirm('确认删除？').then(() => {
    props.prop.jumpActions.splice(index, 1)
  })
}
</script>
<style scoped>
.bs-route-container {
  border: 1px solid rgb(210, 210, 210);
}

.bs-route-item {

}
</style>